import React from 'react';
import { useUser } from '@lore/auth';
import { useConnect } from '@lore/query-connect';
import ParentLayout from '../Layout';
import Navigation from '../../../dialogs_common/Navigation';
import Urls from '../Urls';
import Form from './Form';
import { PayloadStates } from '@lore/utils';
import useRouter from '../../../hooks/useRouter';

export default function Layout(props) {
  const { location, history, match } = useRouter();
  const user = useUser();
  const event = useConnect('event.byId', {
    id: Number(match.params.eventId)
  });

  if (event.state === PayloadStates.FETCHING) {
    return null;
  }

  return (
    <ParentLayout
      event={event}
      page="Documents"
      title="Do you have any supporting documents to help partners understand your event?"
      description={(
        <>
          <span className="font-semibold italic">TIP</span>: The most useful documents will help
          the partner understand you and your students' ideas and needs. You can always provide
          more logistical information after you've connected. This is a great place to include
          examples from previous years, student questions, etc.
        </>
      )}
    >
      <Form
        user={user}
        event={event}
        navigation={(
          <Navigation v5={true} activeStep={13} steps={13}/>
        )}
        onPrevious={(newData) => history.push(Urls(event).LOCATION)}
        onNext={(newData) => history.push(Urls(event).SEARCH_EXPLANATION)}
        onSkip={() => history.push(Urls(event).SEARCH_EXPLANATION)}
        onExit={() => history.push(Urls(event).EVENT_EDIT)}
      />
    </ParentLayout>
  );
};
